import { render } from "./TradingCentre.vue?vue&type=template&id=475adfdc"
import script from "./TradingCentre.vue?vue&type=script&lang=js"
export * from "./TradingCentre.vue?vue&type=script&lang=js"

import "./TradingCentre.vue?vue&type=style&index=0&id=475adfdc&lang=css"

import exportComponent from "C:\\Users\\Ray Wang\\Desktop\\tubertrader\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__